[data-no-op] {
  position: absolute;
  height: 100%;
  width: 100%;
  text-align: center;
}

[data-no-op] p[data-no-op-msg] {
  position: absolute;
  text-align: center;
  font-size: 25px;
  left: 0;
  right: 0;
  color: white;
  padding: 10px;
  /* center vertically */
  top: 50%;
  transform: translateY(-50%);
  max-height: 100%;
  overflow: auto;
}

[data-no-op] canvas[data-no-op-canvas] {
  background-color: #777;
  height: 100%;
  width: 100%;
}
